import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import {
    Loader,
    Container,
    Title,
    MessageCard,
    MarketplaceDashboard,
    MarketplacePurchaseFlow
} from '@simplybenefits/sb-ui-library';

import {
    getInvoice,
    getMarketplaceProduct,
    purchaseMarketplaceProduct,
    getMarketplaceProductRate,
    terminateMarketplaceProduct,
    applyInvoiceCarryForward,
    blockProductCoverage
} from '../../../actions/users';

import { downloadPDFToBrowser } from '../../../services/helpers.js';

class Marketplace extends PureComponent {
    state = {
        selectedProduct: null
    };

    /**
     * @param userID
     * @param productID
     * @returns {Promise<void>}
     * @private
     */
    _selectProduct = async (userID, productID) => {
        const selectedProduct = await this.props.dispatch(getMarketplaceProduct(userID, productID));

        this.setState({
            selectedProduct
        });
    };

    render() {
        const { marketplace } = this.props;
        const hasBanking = Number(this.props.meta.paymentsSetup) === 1;

        if (this.props.loader?.isLoading || !marketplace) {
            return <Loader isContainer/>;
        }

        return (
            <Container>
                <div style={{ display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center' }}>
                    <Title title="Marketplace" customStyle={{ flex: 1 }} />
                </div>

                {
                    !hasBanking &&
                        <MessageCard
                            title="No Banking Data"
                            subtitle="The member has not setup their payment information with Simply Benefits. You cannot purchase Marketplace products for them until they have provided their banking details."
                            small
                        />
                }

                <MarketplaceDashboard
                    isMasterSite={ true }
                    dispatch={ this.props.dispatch }
                    whitelabel={{}}
                    member={ this.props.meta }
                    hasBanking={ hasBanking }
                    purchasedProducts={ this.props.marketplace.purchasedProducts }
                    availableProducts={ this.props.marketplace.availableProducts }
                    refusedProducts={ this.props.marketplace.refusedProducts }
                    coverageBlocks={ this.props.marketplace.coverageBlocks }
                    invoices={ this.props.invoices || []}
                    selectProduct={ (...params) => this._selectProduct(this.props.meta.userID, ...params) }
                    getInvoice={ (...params) => this.props.dispatch(getInvoice(this.props.meta.userID, ...params)) }
                    terminateProduct={ (...params) => this.props.dispatch(terminateMarketplaceProduct(this.props.meta.userID, ...params)) }
                    userID={ this.props.meta.userID }
                    downloadPDFToBrowser={ (...params) => downloadPDFToBrowser(...params) }
                    applyCarryForwardBalance={(...params) => this.props.dispatch(applyInvoiceCarryForward(this.props.meta.userID, ...params)) }
                />

                {
                    this.state.selectedProduct &&
                        <MarketplacePurchaseFlow
                            isMasterSite={ true }
                            loading={ this.props.loading }
                            whitelabel={{}}
                            member={ this.props.meta }
                            selectedProduct={ this.state.selectedProduct }
                            purchaseProduct={ (...params) => this.props.dispatch(purchaseMarketplaceProduct(this.props.meta.userID, ...params)) }
                            blockProductCoverage={ (...params) => this.props.dispatch(blockProductCoverage(this.props.meta.userID, ...params)) }
                            getRate={ (...params) => getMarketplaceProductRate(...params)}
                            onClose={ () => {
                                this.setState({
                                    selectedProduct: null
                                });
                            }}
                        />
                }
            </Container>
        );
    }
}

/**
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    meta: state.users.currentUser.meta,
    marketplace: state.users.currentUser.marketplace,
    invoices: state.users.currentUser.invoices,
    dependents: state.users.currentUser.dependents
});

export default connect(mapStateToProps)(Marketplace);